import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';
//import * as moment from 'moment-timezone';
import { UtilService } from '../services/util.service';


@Pipe({
    name: 'dateTimeFormat',
    standalone: false
})
export class DateTimeFormatPipe implements PipeTransform {
  constructor(public appService: AppService, private utilService: UtilService){}

  transform(date: any,format?:string, locale?:string, timeFormat?: string): any {
    //let default_format = format ? format : this.appService._default_user_data['data_format'];
    //let time_format = timeFormat ? timeFormat : this.appService._default_user_data['time_format'];
    //let time_zone = timeFormat ? timeFormat : this.appService._default_user_data['timezone'];
   
    return this.utilService.dateTimeFormat(date);

  }
}
